// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__LTO3J","description":"PatientConsentPreview_description__Vx08D"};